import { Flex, Image, Text } from "@chakra-ui/react";

type ExperienceTileProps = {
    data: {
        image: string;
        title: string;
        subtitle: string;
    }
}

const ExperienceTile = ({data}: ExperienceTileProps) => {

    return (
      <Flex border="1px solid #E9EEF1" width='100%' align='center' boxShadow='0px 20px 25px -5px rgba(151, 151, 151, 0.1), 0px 10px 10px -5px rgba(151, 151, 151, 0.04)' borderRadius='50px'>
          <Flex width="300px" paddingLeft='24px' paddingTop='24px'paddingRight='24px' >
                <Image src={data.image} marginBottom={4} borderRadius='50px' />
        </Flex>
        <Flex flexDirection='column' marginLeft={10}>
            <Text fontWeight={400} fontSize="12px">{data.title}</Text>
            <Text fontWeight={700} fontSize="18px">{data.subtitle}</Text>
        </Flex>
      </Flex>
    );
  };
  
  export { ExperienceTile };
  